import React from "react";
import Select, {CSSObjectWithLabel, StylesConfig} from "react-select";

import "./styles.scss";

type SelectStyleState = {
	isSelected: boolean;
	isFocused: boolean;
};

interface CustomSelectProps {
	label?: string;
	[key: string]: any;
}

const CustomSelect = ({label, ...props}: CustomSelectProps) => {
	const customSelectStyles: StylesConfig<any, false> = {
		container: (provided: CSSObjectWithLabel) => ({
			...provided,
			width: "100%"
		}),
		valueContainer: (provided: CSSObjectWithLabel) => ({
			...provided,
			padding: "0 8px"
		}),
		placeholder: (provided: CSSObjectWithLabel) => ({
			...provided,
			color: "#4a4a4a"
		}),
		singleValue: (provided: CSSObjectWithLabel) => ({
			...provided,
			height: "100%"
		}),
		control: (provided: CSSObjectWithLabel, state: any) => ({
			...provided,
			borderRadius: "0",
			cursor: "pointer",
			border: "2px solid $main-gold",
			boxShadow: "0",
			fontFamily: "Avenir-Book",
			fontSize: "14px",
			lineHeight: "20px",
			outline: state.isFocused ? "1px auto black" : "none",
			"@media (max-width: 959px)": {
				fontSize: "16px"
			},
			"&:hover": {
				border: "2px solid $main-gold"
			},
			"&:active": {
				boxShadow: "0"
			},
			"&:focus": {
				outline: "1px auto black"
			}
		}),
		dropdownIndicator: (provided: CSSObjectWithLabel) => ({
			...provided,
			cursor: "pointer",
			color: "$main-gold"
		}),
		indicatorSeparator: (provided: CSSObjectWithLabel) => ({
			...provided,
			display: "none"
		}),
		menu: (provided: CSSObjectWithLabel) => ({
			...provided,
			margin: 0,
			borderRadius: 0,
			fontFamily: "Avenir-Book",
			fontSize: "14px",
			height:"auto",
			borderWidth: "1px 1px",
			borderStyle: "solid",
			borderColor: "hsl(0,0%,80%)"
		}),
		menuList: (provided: CSSObjectWithLabel) => ({
			...provided,
			padding: 0,
			borderWidth: "0px 0px",
			borderStyle: "solid",
			borderColor: "#000000"
		}),
		option: (provided: CSSObjectWithLabel, state: any) => ({
			...provided,
			borderBottom: "2px solid $main-gold",
			cursor: "pointer",
			background: state.isFocused ? "#CCC" : "#FFF",
			color: "#000000",
			display: state.isSelected ? "none" : "block"
		}),
		noOptionsMessage: (provided: CSSObjectWithLabel) => ({
			...provided,
			borderBottom: "2px solid $main-gold",
			background: "#FFF"
		})
	};

	return (
		<div className="custom-select-wrapper">
			{label && <div className="label">{label}</div>}
			<Select isMulti={false} isSearchable={false} styles={customSelectStyles} {...props} />
		</div>
	);
};

export default CustomSelect;
